// SPDX-License-Identifier: AGPL-3.0-or-later

import {router} from '@app/app/Router';
import * as AnalyticsCommands from '@app/features/analytics/commands/AnalyticsCommands';
import Config from '@app/features/app/config/Config';
import {isDesktop} from '@app/features/ui/utils/NativeUtils';
import {useEffect} from 'react';

// With no measurement id configured start() does nothing.
export function useAnalytics(): void {
	useEffect(
		() =>
			AnalyticsCommands.start({
				measurementId: Config.PUBLIC_GA4_MEASUREMENT_ID,
				router,
				platform: isDesktop() ? 'desktop' : 'web',
				appVersion: Config.PUBLIC_BUILD_VERSION,
			}),
		[],
	);
}
